import { render, staticRenderFns } from "./videoConfig.vue?vue&type=template&id=26a4e664&"
import script from "./videoConfig.vue?vue&type=script&lang=js&"
export * from "./videoConfig.vue?vue&type=script&lang=js&"
import style0 from "./videoConfig.vue?vue&type=style&index=0&id=26a4e664&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports